export default __webpack_public_path__ + "static/media/DISCLAIMER.ff900569.pdf";